import { useEffect } from 'react';

const SITE = 'https://contactnetwork.cl';

const setMeta = (key, content, attr) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

// Sets document.title + meta description + Open Graph tags + canonical for
// a standalone marketing page, and scrolls to the top on mount (CRA has no
// server-rendered <head> per route, so this is the only way a React Router
// SPA page gets correct per-page SEO tags without pulling in react-helmet).
const useSeoMeta = ({ title, description, path }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    if (title) {
      document.title = title;
      setMeta('og:title', title, 'property');
    }
    if (description) {
      setMeta('description', description, 'name');
      setMeta('og:description', description, 'property');
    }
    if (path) {
      const url = `${SITE}${path}`;
      setCanonical(url);
      setMeta('og:url', url, 'property');
    }
    setMeta('og:type', 'website', 'property');
  }, [title, description, path]);
};

export default useSeoMeta;
